export const CUI_DISABLED_FEATURE_TOOLTIP =
  'This feature is not available in CUI organizations. Switch to a non-CUI organization to use this feature.'
